// Display formatters for the client.

/**
 * Format a decimal hours value as "<h>h<mm>" (Phase E.2).
 *   8.5 → "8h30", 9.4 → "9h24", 6.6 → "6h36", 8.0 → "8h00".
 * Rounds to the nearest minute (carry handled: 8.999 → "9h00").
 * Non-finite input returns an em-dash.
 */
export function formatHoursToHMM(decimal: number): string {
  if (!Number.isFinite(decimal)) return '—';
  const sign = decimal < 0 ? '-' : '';
  const totalMin = Math.round(Math.abs(decimal) * 60);
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  return `${sign}${h}h${String(m).padStart(2, '0')}`;
}

/**
 * Format a DA amount with fr-FR thousand grouping using plain spaces
 * ("65 000"). Null/undefined/NaN → em-dash. The narrow no-break
 * spaces fr-FR emits are normalized to regular spaces (matches the
 * Salaires design prototype's sbFmt).
 */
export function fmtDA(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return '—';
  return Math.round(n).toLocaleString('fr-FR').replace(/ /g, ' ');
}
